module.exports = __webpack_public_path__ + "9f76068f1eefacf3acacb2e6640c3261.png";